import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { Identifiable, Planzone, PlanzoneSettings } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  editProjectElementDetailsConfiguration(
    req: Boundaries["editProjectElementDetailsConfiguration"]["request"],
  ): void;
}

function useEditProjectElementDetailsConfiguration(
  planzone: Identifiable<Planzone>,
): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isEditProjectElementDetailsConfigurationRequestPending(planzone),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isEditProjectElementDetailsConfigurationRequestSuccess(planzone),
    ),
    isRequestFailure: useSelector(() =>
      selector.isEditProjectElementDetailsConfigurationRequestFailure(planzone),
    ),
    editProjectElementDetailsConfiguration:
      core.editProjectElementDetailsConfiguration,
  };
}

export { useEditProjectElementDetailsConfiguration };
